import { createContext } from "react";

export const EvaluateContext = createContext({
    value:{},
    setValue :(value) =>{}

});